angular.module('unica_notification.notification_controllers')

.controller('NotificationListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, $uibModal,
	NotificationListService, NotificationDeleteService, NotificationSendService
) {
	$scope.event_id = $stateParams.event_id;

	$rootScope.getEvent( $stateParams.event_id );

	$scope.notificationList = [];
	$scope.loadNotifications = function()
	{
		$scope.showLoader();
		NotificationListService
			.list($scope.event_id)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.notificationList = data;
				}
			});
	};

	$scope.loadNotifications();


	$scope.deleteNotification = function(notificationId)
	{
		$confirm({
			title: 'Sei sicuro di voler eliminare la campagna?',
			text: 'Confermi la cancellazione della campagna?'
		}).then(function() {

			$scope.showLoader();

			NotificationDeleteService
				.delete( notificationId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						angular.forEach($scope.notificationList, function(notification, key) {
							if ( notification.id === notificationId ) {
								$scope.notificationList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Campagna eliminata con successo!', '');
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.sendNotification = function(notificationId)
	{
		$confirm({
			title: 'Sei sicuro di voler inviare questa notifica?',
			text: 'Confermi l\'invio della notifica?'
		}).then(function() {

			$scope.showLoader();

			NotificationSendService
				.send( notificationId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.showSuccessMsg( data.sent + ' notifiche inviate con successo!', '');

						$scope.loadNotifications();
					}
				});

		}, function() {
			// Cancel
		});
	};

	$scope.resendNotification = function(notificationId)
	{
		$confirm({
			title: 'Attenzione! Invio già eseguito. Sei sicuro di voler inviare di nuovo questa notifica?',
			text: 'Confermi il reinvio della notifica?'
		}).then(function() {

			$scope.showLoader();

			NotificationSendService
				.send( notificationId )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.showSuccessMsg( data.sent + ' notifiche inviate con successo!', '');

						$scope.loadNotifications();
					}
				});

		}, function() {
			// Cancel
		});
	};


	$scope.openNotificationInvitationsModal = function (eventId, notificationId)
	{
		var modalInstance = $uibModal.open({
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			controller: 'ModalNotificationInvitationsInstanceController',
			controllerAs: '$ctrl',
			templateUrl: './templates/modals/notification-invitations.html',
			size: 'lg',
			windowClass: 'modal-invitation-list',
			resolve: {
				notificationId: function () {
					return notificationId;
				},
				eventId: function() {
					return eventId;
				}
			}
		});
	};


})

.controller('ModalNotificationInvitationsInstanceController',
	function ($scope, $uibModalInstance, eventId, notificationId, NotificationAssignService) {

		$scope.notificationEmails = [];

		$scope.loadNotificationEmails = function() {
			$scope.showLoader();

			NotificationAssignService
				.list( eventId, notificationId  )
				.then(function(data) {
					$scope.hideLoader();

					if ( data ) {
						$scope.notificationInvitations = data;
					}
				});
		};
		$scope.loadNotificationEmails();


		$scope.closeModal = function() {
			$uibModalInstance.dismiss('cancel');
		};

	});